import Image from 'next/image';
import classNames from 'classnames';
import { toNumberCommas } from '@/utils/string-helpers';
import { getCdnUrl } from '@/utils/url';
import { useVariantContextValues } from '../context/use-variant-context-values';
interface Props {
  mode: 'mobile' | 'desktop';
  className?: string;
}
function SnappPayMessage({
  mode,
  className
}: Props) {
  const {
    activePricing
  } = useVariantContextValues('pdp');
  const {
    effectivePrice,
    isSalable
  } = activePricing;
  if (!isSalable || !effectivePrice || effectivePrice < 50000) return <span className='lg:h-12' />;
  const count = 4;
  const amount = Math.ceil(effectivePrice / count);
  const message = mode === 'mobile' ? `${count} قسط ماهانه ${toNumberCommas(amount)} تومانی با اسنپ‌پی! (بدون کارمزد)` : `${count} قسط ماهانه ${toNumberCommas(amount)} تومانی با اسنپ‌پی!`;
  return <div className={classNames('w-full items-center gap-2 lg:gap-0.5', {
    'flex bg-alert-info-light px-2 py-1.5 lg:hidden': mode === 'mobile'
  }, {
    'hidden lg:flex': mode === 'desktop'
  }, className)} data-sentry-component="SnappPayMessage" data-sentry-source-file="snapp-pay-message.tsx">
            <Image unoptimized src={getCdnUrl('/_toad/images/icons/snapp-pay.svg')} alt='snapp pay icon' className='shrink-0' height={24} width={24} data-sentry-element="Image" data-sentry-source-file="snapp-pay-message.tsx" />
            <span className='text-caption-12 text-alert-info-dark lg:text-body-14'>{message}</span>
        </div>;
}
export default SnappPayMessage;